import React from 'react';

interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
  className?: string;
}

export const ClaimDetailsTabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  className,
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`claim-details-tabpanel-${index}`}
      aria-labelledby={`claim-details-tab-${index}`}
      className={`tab-panel ${className || ''}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
};
